import { render, staticRenderFns } from "./Newfhkbody.vue?vue&type=template&id=15c8a50e&scoped=true&"
import script from "./Newfhkbody.vue?vue&type=script&lang=js&"
export * from "./Newfhkbody.vue?vue&type=script&lang=js&"
import style0 from "./Newfhkbody.vue?vue&type=style&index=0&id=15c8a50e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c8a50e",
  null
  
)

export default component.exports